// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".light-theme .user-group-dropdown>div{color:#333 !important}.dark-theme .user-group-dropdown>div{color:#c8c3bc !important}.user-group-dropdown.ui.dropdown .menu>.header{font-size:14px !important;height:32px}.light-theme .user-group-dropdown.placeholder-text>div{color:#b6c1c6 !important}.dark-theme .user-group-dropdown.placeholder-text>div{color:#bfb9b1 !important}", ""]);
// Exports
module.exports = exports;
